import { ApiError } from '../../lib/identityAuth';
import { config } from '../../lib/config';

// Devices are never deleted from this portal; deletion/removal is blocked while devices are attached.
const IN_USE_CODES = new Set(['FACILITY_IN_USE', 'AREA_IN_USE']);

export function newAreaId(): string {
  const rand =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().replace(/-/g, '').slice(0, 12)
      : Math.random().toString(36).slice(2, 14);
  return `area_${rand}`;
}

export function describeFacilityError(error: unknown): string {
  if (error instanceof ApiError && error.code && IN_USE_CODES.has(error.code)) {
    const suffix = config.defaultCoreUrl ? ` (${config.defaultCoreUrl})` : '';
    return `This facility or area still has devices assigned. Open the Sense Core site${suffix} to move or delete those devices, then try again.`;
  }
  return error instanceof Error ? error.message : 'Request failed';
}
